import type { OakStreamInternalOptions } from "./types";

import { createStreamHash } from "./hash";
import { Stream } from "./stream";

export class StreamCache {
  private readonly streams = new Map<string, Stream>();

  build(options: OakStreamInternalOptions) {
    const hash = createStreamHash(options);
    const existingStream = this.streams.get(hash);

    if (existingStream === undefined) {
      const nextStream = new Stream({
        hash,
        url: options.url,
        getIdTokenRefreshIfExpired: options.getIdTokenRefreshIfExpired,
        initialLastEventId: options.initialLastEventId,
        removeFromCache: (streamHash) => {
          this.remove(streamHash);
        },
      });

      this.streams.set(hash, nextStream);

      return nextStream;
    }

    return existingStream;
  }

  get(hash: string) {
    return this.streams.get(hash);
  }

  remove(hash: string) {
    this.streams.delete(hash);
  }

  close() {
    const cachedStreams = [...this.streams.values()];

    this.streams.clear();

    for (const stream of cachedStreams) {
      stream.close();
    }
  }
}

export function createOakStreamClient() {
  return new StreamCache();
}
